import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.css']
})
export class UserDetailsComponent implements OnInit {
  userId!: number;
  user: any;

  constructor(private route: ActivatedRoute, private apiService: ApiService) { }

  ngOnInit(): void {
    this.userId = +this.route.snapshot.paramMap.get('id')!;

    this.apiService.getUserById(this.userId).subscribe({
      next: (res: any) => {
        if (res && res) {
          this.user = res;
        } else {
          console.error('User data not found');
        }
        console.log('User data:', this.user);
      },
      error: (err) => {
        console.log(err);

      },
      complete: () => console.log('Observable complete'),
    });

   
  }

}